import cleanDeep from "clean-deep";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import { Actions as COMPANY_ACTIONS } from "../../../store/actions/companyActions";
import { Actions as OVERTIME_ACTIONS } from "../../../store/actions/overtimeActions";

import { CheckCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import { cloneDeep, orderBy } from "lodash";
import { MentionsInput, Mention } from "react-mentions";
import MentionInputStyle from "@/components/report/MentionInputStyle";

const reportNames = [
	{
		label: "Payslip",
		field: "payslip"
	},
	{
		label: "Payroll Reports",
		field: "payrollReports"
	},
	{
		label: "Default",
		field: "default"
	}
]

const mentionStyle = {
	backgroundColor: "rgb(255, 222, 205)",
	borderRadius: "5px",
	padding: 1,
	marginLeft: -1,
	marginRight: -1,
	fontSize: "13px",
	// lineHeight: "18px",
	// fontWeight: "bold",
	// color: "white"
};

const ReportSettings = ({
	overtimes,
	addOvertime,
	updateCompanyDetails,
	updateSetting,
	currentOrg,
	reports
}) => {

	const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

		updateCompanyDetails(
			cleanDeep(
				{
					org: String(currentOrg),
					reports: reports,
				},
				{ emptyStrings: false, emptyArrays: false, emptyObjects: false },
			),
		);
	};

	return (
		<form
			onSubmit={onSubmit}
			style={{ paddingBottom: 30 }}
            className="px-8"
		>

			<div className="form-section col-xs-12">
				<div className="col-xs-12">
					<div className="pull-left">
						<h4>Default Report Names</h4>
					</div>
				</div>
				{reportNames.map((report, index) => (
					<div className="col-xs-12 py-2" key={index}>
						<div className="col-xs-2" style={{paddingTop: 9}}>
							<label>{report.label}</label>
						</div>
						<div className="col-xs-10">
							<MentionsInput
									markup="@[__display__]"
									value={reports?.[report.field] ?? ''}
									onChange={(event) => {
										updateSetting(`reports.${report.field}`,  event.target.value);
									}}
									style={{
										...MentionInputStyle,
									}}
								>
									<Mention
										trigger="@"
										data={[
											{ id: "reportName", display: "Report Name" },
											{ id: "companyName", display: "Company Name" },
											{ id: "startDate", display: "Start Date" },
											{ id: "endDate", display: "End Date" },
											{ id: "payFrequencyName", display: "Pay Frequency Name" },
											{ id: "payPeriodNo", display: "Pay Period No" },
											{ id: "payPeriodYear", display: "Pay Period Tax Year" },
											{ id: "employeeFullName", display: "Employee Full Name" },
										]}
										style={mentionStyle}
										singleLine={true}
									/>
								</MentionsInput>
						</div>
					</div>
				))}
				<div className="clearfix" />

			</div>

			<div className="col-xs-12 pr-0 text-right">

					<button
						className="btn btn-success"
						type="submit"
					>
						<CheckCircleIcon style={{ height: "1.5em", float: "left" }} />
						<div style={{ float: "left" }}>Save</div>
					</button>
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	const settings = cloneDeep(state.company?.settings);

	if (typeof settings?.showEmployerContributions == "undefined") {
		settings.showEmployerContributions = true;
	}

	return {
		currentOrg: state.company?.settings?.org,
		reports: state.company?.settings?.reports ?? {},
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateSetting: (field,newValue) => dispatch(COMPANY_ACTIONS.updateSetting(field,newValue)),
	updateCompanyDetails: (body) => dispatch(COMPANY_ACTIONS.updateCompanyDetails(body)),
	addOvertime: () => dispatch(OVERTIME_ACTIONS.addOvertime(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportSettings);
